import React from 'react';
import styled from 'styled-components';

// 无数据展示
export default function NoData({ imgStyle, tip, children, ...others }) {
  return (
    <Root {...others}>
      <Image style={imgStyle} src={require('./noData.png')} />
      <Tip className='tip'>{tip || '暂无数据'}</Tip>
      {children}
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Image = styled.img`
  width: 160px;
  height: 160px;
`;

const Tip = styled.div`
  color: var(--td-font-gray-2);
  font-size: 14px;
  width: 160px;
  text-align: center;
`;
